import * as React from 'react'

function SvgAntennaChecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0ZM19.501 13c.268 0 .523.053.757.148.229.934.603 1.81 1.097 2.604a2.008 2.008 0 0 1-.885.998l3.993 13.975a1 1 0 0 1-1.923.55L21.89 29h-4.777l-.65 2.275a1 1 0 1 1-1.923-.55l3.993-13.975A2 2 0 0 1 19.5 13Zm1.817 14-.285-1H17.97l-.286 1h3.634Zm-1.817-6.36.96 3.36h-1.92l.96-3.36Z"
      />
      <path d="M22.861 18.24c.131-.102.256-.212.374-.328a9.02 9.02 0 0 0 1.688 1.114c-.238.266-.5.512-.782.735a1 1 0 0 1-.64.24 1 1 0 0 1-.64-1.76ZM25.361 20.231a6.86 6.86 0 0 0 .768-.699c.706.238 1.451.39 2.223.445a8.839 8.839 0 0 1-1.71 1.794 1.001 1.001 0 1 1-1.28-1.54ZM12.703 8.045a1.001 1.001 0 0 0-.343.186A8.84 8.84 0 0 0 9 15.001a8.84 8.84 0 0 0 3.36 6.77 1.001 1.001 0 1 0 1.28-1.54 6.87 6.87 0 0 1-2.64-5.23 6.87 6.87 0 0 1 2.64-5.23 1.002 1.002 0 0 0-.937-1.726Z" />
      <path d="M15.586 10.013a1 1 0 0 1 .675.348 1 1 0 0 1-.12 1.4 4.28 4.28 0 0 0-1.64 3.24 4.28 4.28 0 0 0 1.64 3.24 1 1 0 0 1 .12 1.4 1 1 0 0 1-1.4.12 6.197 6.197 0 0 1-2.36-4.76 6.198 6.198 0 0 1 2.36-4.76 1 1 0 0 1 .725-.228Z" />
    </svg>
  )
}

export default SvgAntennaChecked
